export const contributorTypedb = [
    { value: '01', label: 'Gran contribuyente', id: '1072' },
    { value: '02', label: 'Contribuyente mediano', id: '1073' },
    { value: '03', label: 'Contribuyente pequeño', id: '1074' },
    { value: '04', label: 'Otro', id: '1075' }
  ]